module.exports = __webpack_public_path__ + "assets/shop.d4f8e5d2.svg";